import { BasicButton } from "../../button/BasicButton";
import { PrimaryButton } from "../../button/PrimaryButton";
import { Link } from "../../link/Link";
import { Stack } from "../../../foundations/grid-layout/Stack";
import { PopoverActions } from "../../popover/PopoverActions";

import { Trans } from "react-i18next";
import { useContext } from "react";

import {
  OverlayTriggerStateContext,
  ColorPickerStateContext,
} from "react-aria-components";

import { parseColor } from "@react-stately/color";
import { css } from "@emotion/css";
interface ColorPickerActionsProps {
  testID: string;
  onCancel?: () => void;
  onDone?: (color: string) => void;
  onReset?: () => void;
  originalColor?: string;
}

export function ColorPickerActions({
  testID,
  onCancel,
  onDone,
  onReset,
  originalColor,
}: ColorPickerActionsProps) {
  const overlayState = useContext(OverlayTriggerStateContext);
  const colorPickerState = useContext(ColorPickerStateContext);

  const handleCancel = () => {
    if (originalColor && colorPickerState) {
      colorPickerState.setColor(parseColor(originalColor));
    }
    onCancel?.();
    overlayState?.close();
  };

  const handleDone = () => {
    const currentColor = colorPickerState?.color?.toString("hex") || "";
    onDone?.(currentColor);
    overlayState?.close();
  };

  const handleReset = () => {
    if (originalColor && colorPickerState) {
      colorPickerState.setColor(parseColor(originalColor));
    }
    onReset?.();
    overlayState?.close();
  };

  return (
    <PopoverActions className={styles.popoverActions}>
      <Stack
        orientation="horizontal"
        justify="space-between"
        className={styles.flexOne}
      >
        <Link
          textStyle="global/body-secondary"
          textColor="text-weak"
          testID={`${testID}-reset`}
          onPress={handleReset}
        >
          <Trans>Reset</Trans>
        </Link>
        <Stack orientation="horizontal" gap="space-2">
          <BasicButton
            size="small"
            onPress={handleCancel}
            testID={`${testID}-cancel`}
          >
            <Trans>Cancel</Trans>
          </BasicButton>
          <PrimaryButton
            size="small"
            onPress={handleDone}
            testID={`${testID}-done`}
          >
            <Trans>Done</Trans>
          </PrimaryButton>
        </Stack>
      </Stack>
    </PopoverActions>
  );
}

const styles = {
  popoverActions: css({
    paddingLeft: "var(--space-0)",
    paddingRight: "var(--space-0)",
  }),
  flexOne: css({
    flex: "1 1 auto",
  }),
};
